import { Component, OnInit, ViewChild } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { imagesPOIDir } from "../../../global.config";
import { GeocodingService } from "../../../utils/leaflet/service/geocoding.service";
import { MapService } from "../../../utils/leaflet/service/map.service";
import { PointInterest, RapportDto } from "../data-management.model";
import { DataManagementService } from "../data-management.service";
import * as L from 'leaflet';
import { ImportExportService } from "../../import-export/import-export.service";
import {Icon, Marker, Polygon} from "leaflet";
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TypePoiRequestDto, TypePoiResponseDto } from "./type-poi/type-poi.model";
import { TypePoiRestService } from "./type-poi/type-poi-rest.service";
import { TypePoiStateService } from "./type-poi/type-poi-state.service";


@Component({
  selector: "app-poi",
  templateUrl: "./poi.component.html",
  styleUrls: ["./poi.component.css"]
})
export class PoiComponent implements OnInit {

  importExport = true;


  @ViewChild('importModal', { static: false }) public importModal!: ModalDirective;

  @ViewChild('poiDeleteModal', { static: false })
  poiDeleteModal: ModalDirective;

  /** all poi*/
  //pointInterests: PointInterest[] = [];

  /** selected poi*/
  pointInterest: PointInterest = new PointInterest();

      /** import  */
  selectedItem = 'POI';

  /** matker poi*/
  pointInterestsPoint: PointInterest[] = [];

  /** polygon poi*/
  pointInterestsPolygon: PointInterest[] = [];

  repport: RapportDto = new RapportDto();

  public searchTerm: string = null;
  /** poi by page*/
  dataPoint:any[] = [];
  dataPolygon:any[] = [];

  // pag vars
  public page: number = 1;
  public itemsPerPage: number = 25;
  public maxSize: number = 5;

  public pagePolgygon: number = 1;
  public itemsPerPagePolgygon: number = 25;
  public maxSizePolgygon: number = 5;
  /** delete modal */

  /** current selected poi */
  selectedPoi: PointInterest
  /** loader */
  loading = false;

  isDataLoaded: boolean = false;

  @ViewChild('childModal', { static: false }) public childModal: ModalDirective;

  /* ========== TYPE POI VAR START ==============*/
  @ViewChild('TypePoiModal', { static: false })
  TypePoiModal: ModalDirective;
  @ViewChild('typePoiDeleteModal',{static:false})
  typePoiDeleteModal:ModalDirective
  isTypePoiLoading :boolean = false;
  typePoiList:TypePoiResponseDto[]=[];
  whichOne:'TypePoi' | 'Poi' = 'Poi'
  canAddTypePoi:boolean = false;
  mode:'ADD' | 'UPDATE' = 'ADD';
  selectedTypePoi:TypePoiResponseDto;
  deleteTypePoiLoading:boolean = false;
  typePoiItems: { text: string | number; id: number }[] = [];
  typePoiSelected: number[] = [];
  /* =========== TYPE POI VAR END ===========*/

  user:any;
  isCollapsed:boolean = false;
  public showChildModal(): void {
    if (this.childModal) {
      this.childModal.show();
    }
  }

  constructor(
    private mapService: MapService,
    private dataManagementService: DataManagementService,
    private geocodingService: GeocodingService,
    public toastr: ToastrService,
    public exportImport: ImportExportService,
    private typePoiRestService:TypePoiRestService,
    private typePoiStateService:TypePoiStateService
  ) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem("currentUser"));
    this.loadPOI();
    this.loadTypePoi();

    this.typePoiStateService.getTypePois().subscribe({
        next:(typepois)=>{
          this.typePoiItems = [];
            typepois.forEach(t => {
              this.typePoiItems.push({id:t.id , text:t.nom})
            })
        }
      })
  }

  //GET list of Points and Polygons
  loadPOI() {
    if (this.dataManagementService.pointInterests) {
      this.dataManagementService.pointInterests.forEach(pointInterest => {
        if (pointInterest.type == "MARKER") {
          this.pointInterestsPoint.push(pointInterest);
        } else if (pointInterest.type == "POLYGON") {
          this.pointInterestsPolygon.push(pointInterest);
        }
      });
      this.PageChangePoint({
        page: this.page,
        itemsPerPage: this.itemsPerPage
      });
      this.PageChangePolygon({
        page: this.pagePolgygon,
        itemsPerPage: this.itemsPerPagePolgygon
      });
      this.isDataLoaded = true;
    } else {
      this.dataManagementService
        .getAllPointInterests()
        .subscribe(pointInterests => {
          pointInterests.forEach(pointInterest => {
            if (pointInterest.type == "MARKER") {
              this.pointInterestsPoint.push(pointInterest);
            } else if (pointInterest.type == "POLYGON") {
              this.pointInterestsPolygon.push(pointInterest);
            }
          });
          this.dataManagementService.pointInterests = pointInterests;
          this.PageChangePoint({
            page: this.page,
            itemsPerPage: this.itemsPerPage
          });
          this.PageChangePolygon({
            page: this.pagePolgygon,
            itemsPerPage: this.itemsPerPagePolgygon
          });
          this.isDataLoaded = true;
          this.dataManagementService.setPoiInterest(pointInterests);
        });
    }
  }

  //Pagination of Polygon page
  PageChangePolygon(page: any) {
    let start = (page.page - 1) * page.itemsPerPage;
    let end =
      page.itemsPerPage > -1
        ? start + page.itemsPerPage
        : this.pointInterestsPolygon.length;
    this.dataPolygon = this.pointInterestsPolygon.slice(start, end);
  }

  deletePointPolygon(poi: PointInterest) {
    this.selectedPoi = poi;
    this.poiDeleteModal.show();
  }
  onDelete() {
    this.deletePOI(this.selectedPoi);
  }

  initPoints() {
    this.whichOne = 'Poi';
    var markersListLength = this.dataManagementService.pointInterests!.filter(
      pointInterest => pointInterest.type == "MARKER"
    ).length;

    // init !
    this.pointInterestsPoint = [];
    this.dataPoint = [];

    this.dataManagementService.pointInterests!.forEach(pointInterest => {
      if (pointInterest.type == "MARKER") {

        /** SEARCH WITH NAME IF VAR searchTerm EXISTS */
        if ((this.searchTerm != null && this.searchTerm.length > 0) || (this.typePoiSelected && this.typePoiSelected.length >0)) {
          if(this.searchTerm != null && this.searchTerm.length > 0){
            if (pointInterest.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) != -1) {
               this.pointInterestsPoint.push(pointInterest);
            }
          }
        } else {
          this.pointInterestsPoint.push(pointInterest);
        }
      }
    });

    /** if deleted element is the last element in the page*/
    if (markersListLength % this.itemsPerPage === 0) {
      if (this.page > 1) {
        this.page = this.page - 1;
      } else {
        this.page = 1;
      }
    }

    this.PageChangePoint({ page: this.page, itemsPerPage: this.itemsPerPage });
    this.mapService.removeMarkersFromMap();
    this.mapService.removeMarkersPoiFromMap();
    this.mapService.removePolygonsPoiFromMap();
    this.dataPoint.forEach(p =>{
      this.drawPois(p);
    })
  }

  filterPoiByTypePoi(){
    this.pointInterestsPoint = [];
    this.dataManagementService.pointInterests!.forEach(pointInterest => {
      if (pointInterest.type == "MARKER") {
        if (this.typePoiSelected && this.typePoiSelected.length > 0 ) {
          if((this.typePoiSelected && this.typePoiSelected.length > 0)){
            if(pointInterest.typePoi && this.typePoiSelected.includes(pointInterest.typePoi.id)){
              if(!this.pointInterestsPoint.find(p => p.idPointInterest === pointInterest.idPointInterest)){
                this.pointInterestsPoint.push(pointInterest);
              }
            }
          }
        } else {
          this.pointInterestsPoint.push(pointInterest);
        }
      }
    });
    this.dataPoint = this.pointInterestsPoint;
    this.mapService.removeMarkersFromMap();
    this.mapService.removeMarkersPoiFromMap();
    this.mapService.removePolygonsPoiFromMap();
    if(this.typePoiSelected && this.typePoiSelected.length > 0 ){
      this.pointInterestsPoint.forEach(p =>{
        this.drawPois(p);
      })
    }

  }

  initPolygons() {
    this.whichOne = "Poi";
    var polygonsListLength = this.dataManagementService.pointInterests!.filter(
      pointInterest => pointInterest.type == "POLYGON"
    ).length;

    // init !
    this.pointInterestsPolygon = [];
    this.dataPolygon = [];

    this.dataManagementService.pointInterests!.forEach(pointInterest => {
      if (pointInterest.type == "POLYGON") {

        /** SEARCH WITH NAME IF VAR searchTerm EXISTS */
        if (this.searchTerm != null && this.searchTerm.length > 0) {
          if (pointInterest.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) != -1) {
            this.pointInterestsPolygon.push(pointInterest);
          }
        } else {
          this.pointInterestsPolygon.push(pointInterest);
        }

      }
    });

    /** if deleted element is the last element in the page*/
    if (polygonsListLength % this.itemsPerPagePolgygon === 0) {
      if (this.pagePolgygon > 1) {
        this.pagePolgygon = this.pagePolgygon - 1;
      } else {
        this.pagePolgygon = 1;
      }
    }

    this.PageChangePolygon({
      page: this.pagePolgygon,
      itemsPerPage: this.itemsPerPagePolgygon
    });
  }

  //Pagination of Point page
  PageChangePoint(page: any) {
    let start = (page.page - 1) * page.itemsPerPage;
    let end =
      page.itemsPerPage > -1
        ? start + page.itemsPerPage
        : this.pointInterestsPoint.length;
    this.dataPoint = this.pointInterestsPoint.slice(start, end);
  }


  deletePOI(point: PointInterest) {
    this.loading = true;
    this.dataManagementService
      .deletePointInterest(point.idPointInterest)
      .subscribe(
        suprimed => {
          this.poiDeleteModal.hide();
          if (suprimed) {
            this.mapService.removeMarkersFromMap();
            this.mapService.removeMarkersPoiFromMap();
            this.mapService.removePolygonsPoiFromMap();

            this.dataManagementService.pointInterests = this.dataManagementService.pointInterests!.filter(
              pointInterest =>
                pointInterest.idPointInterest != point.idPointInterest
            );

            if (point.type == "MARKER") {
              this.initPoints();
            }

            if (point.type == "POLYGON") {
              this.initPolygons();
            }

            this.toastr.success(
              "Operation de suppression est bien effectuée !",
              "info"
            );
            this.loading = false;
          } else {
            this.toastr.error(
              "L'operation de suppression est annulée !",
              "Error"
            );
            this.loading = false;
          }
        },
        () =>
          this.toastr.error("L'operation de suppression est annulée !", "Error")
      );
  }

  updatePOI(pointInterest: PointInterest) {
    if(!pointInterest.typePoi){
      pointInterest.typePoi = new TypePoiResponseDto(0);
    }
    this.pointInterest = pointInterest;
    this.showChildModal();
  }

  drawCircle(pointInterest: PointInterest) {
    let circle = L.circle(pointInterest.coordinate, {
      color: 'red',
      fillColor: '#f03',
      fillOpacity: 0.1,
      radius: pointInterest.ray
    });
    this.mapService.addCircle(circle);

    setTimeout(() => {
      this.mapService.removeCirclesFromMap();
    }, 9000);
  }

  displayPointPolygon(pointInterest: PointInterest) {
    this.toastr.success(
      pointInterest.name +
      " couvre un rayon de " +
      pointInterest.ray +
      " metres",
      "info"
    );

    this.mapService.removeMarkersFromMap();
    this.mapService.removeMarkersPoiFromMap();
    this.mapService.removePolygonsPoiFromMap();

    let nom = "Nom";
    let address = "Adresse"
    if(this.user && this.user.id === 1393){nom = "Référence";address = "Nom"}

    let popup =
      "<span class='leaflet-pelias-layer-icon-container'><div class='leaflet-pelias-layer-icon leaflet-pelias-layer-icon-point' title='layer: venue'></div>" +
      "</span><b> "+nom+" : </b><strong>" + pointInterest.name + "</strong><br><hr>" +
      "<b>"+address+" : " + pointInterest.address + "</b>" +
      "<hr>" +
      pointInterest.coordinate.lat + "," + pointInterest.coordinate.lng;
    let marker: L.Marker<any> | null = null;

    if (pointInterest.type == "POLYGON") {
      let polygon = new Polygon(pointInterest.decode);
      if(pointInterest.plyColor != null)
      polygon.setStyle({fillColor: pointInterest.plyColor, color:pointInterest.plyColor, weight: 2});
      this.mapService.addPolygonPoi(polygon);
    }

    marker = new Marker(pointInterest.coordinate);

    marker.on("click", () => {
      this.mapService.map.setView(pointInterest.coordinate, 17);
    });

    marker.on("mouseover", () => {
      if (pointInterest.type == "MARKER") {
        this.drawCircle(pointInterest);
      }
      marker.openPopup();
    });

    marker.on("add", () => {
      marker.openPopup();
    });

    if (pointInterest.type == "MARKER") {
      this.drawCircle(pointInterest);
    }

    //Edit Marker
    marker.options.draggable = true;
    this.pointInterest = pointInterest;

    marker.on("drag", (e: any) => {
      pointInterest.coordinate = e.target._latlng;
    });

    marker.on("dragend", (e: any) => {
      pointInterest.coordinate = e.target._latlng;
      this.pointInterest.coordinate = e.target._latlng;

      this.geocodingService
        .inverseGeoconding(
          this.pointInterest.coordinate.lat,
          this.pointInterest.coordinate.lng,
          17
        )
        .subscribe(adress => {
          this.pointInterest.address = adress.display_name;
        });
      this.childModal.show();
    });

    marker.bindPopup(popup);
    marker.openPopup();
    let iconUri = ''
    if(pointInterest && pointInterest.typePoi && pointInterest.typePoi.imageUri && pointInterest.typePoi.imageUri.trim() != ''){
       iconUri = pointInterest.typePoi.imageUri;
    }
    else {
      iconUri = imagesPOIDir + pointInterest.imageUri;
    }

    marker.setIcon(
      new Icon({
        iconUrl: iconUri,
        iconAnchor: [-2, 10],
        iconSize: [15, 15],
        popupAnchor: [10, -25]
      })
    );
    this.mapService.addMarkerPoi(marker);
    var mapCenterMarker = new L.LatLng(
      pointInterest.coordinate.lat,
      pointInterest.coordinate.lng - 0.08
    );
    var mapCenterPolygin = new L.LatLng(
      pointInterest.coordinate.lat,
      pointInterest.coordinate.lng - 0.003
    );

    if (pointInterest.type == "POLYGON") {
      this.mapService.map.setView(mapCenterPolygin, 17);
    } else {
      this.mapService.map.setView(mapCenterMarker, 12);
    }
  }

  export() {
    this.repport.type = 'SITE_CLIENT';
    this.exportImport.export(this.pointInterest, this.repport, 0);
}

itemWasImported(res: boolean) {
  if (res) {
      this.importModal.hide();
      this.loadPOI();
  }
}

importMod(){
  this.importModal.show();
}

loadTypePoi(){
  this.isTypePoiLoading = true;
    this.typePoiRestService.getAllTypePoi().subscribe({
      next:(typePois)=>{
        this.typePoiStateService.setTypePois(typePois)
        this.isTypePoiLoading = false;
      },
      error:()=>{
        this.isTypePoiLoading = false;
      }
    })
}

initTypePoi(){
  this.whichOne = 'TypePoi'
  if(this.typePoiStateService.getCurrentTypePois().length === 0){
      this.loadTypePoi();
    }
    this.typePoiStateService.getTypePois().subscribe({
      next:(typePois)=>{
        this.typePoiList = typePois;
      }
    })
}

typePoiWasAdded(typePoi:TypePoiResponseDto) {
        this.TypePoiModal.hide();
        this.loadPoiFromRest();
}
typePoiWasUpdated(typePoi:TypePoiResponseDto) {
        this.TypePoiModal.hide();
        this.loadPoiFromRest();
}

addTypePoi() {
        let tp = new TypePoiRequestDto('#3e64ff','','',[]);
        this.typePoiStateService.setTypePoi(tp)
        this.mode = 'ADD';
        this.TypePoiModal.show();
    }

updateTypePoi(typePoi: TypePoiResponseDto) {
        let tp  = new TypePoiRequestDto()
        tp.id = typePoi.id;
        tp.nom = typePoi.nom;
        tp.color = typePoi.color;
        tp.imageUri = typePoi.imageUri ? typePoi.imageUri : '';
        tp.pointInterestsIds = typePoi.pointInterests.map(p => p.idPointInterest);
        this.typePoiStateService.setTypePoi(tp);
        this.mode = 'UPDATE';
        this.TypePoiModal.show();
}

openDeleteTypePoiModal(typePoi:TypePoiResponseDto){
    this.selectedTypePoi = typePoi;
    this.typePoiDeleteModal.show()
}

onDeleteTypePoi(){
  this.deleteTypePoiLoading = true;
  const typePoiId = this.selectedTypePoi?.id;
  if(typePoiId){
    this.typePoiRestService.deleteTypePoi(typePoiId).subscribe({
      next:()=>{
        this.typePoiStateService.deleteTypePoi(typePoiId)
        this.toastr.success(
              "Operation de suppression est bien effectuée !",
              "info"
            );
        this.deleteTypePoiLoading = false;
        this.typePoiDeleteModal.hide()
      },
      error:()=>{
        this.toastr.error("L'operation de suppression est annulée !", "Error")
        this.deleteTypePoiLoading = false;
        this.typePoiDeleteModal.hide()
      }
    })
  }
}

drawPois(pointInterest: PointInterest) {
    let nom = "Nom";
    let address = "Adresse"
    if(this.user && this.user.id === 1393){nom = "Référence";address = "Nom"}
    let popup =
      "<span class='leaflet-pelias-layer-icon-container'><div class='leaflet-pelias-layer-icon leaflet-pelias-layer-icon-point' title='layer: venue'></div></span> "+nom+" : <strong>" +
      pointInterest.name +
      "</strong><br><hr><b>"+address+" : " +
      pointInterest.address +
      "</b>" +
      "<hr>" +
      pointInterest.coordinate.lat + "," + pointInterest.coordinate.lng;
    let marker: L.Marker<any> | null = null;

    marker = new Marker(pointInterest.coordinate);

    marker.on("mouseover", () => {
      marker.openPopup();
    });

    marker.on("add", () => {
      marker.openPopup();
    });

    //Edit Marker
    marker.options.draggable = true;
    this.pointInterest = pointInterest;

    marker.on("drag", (e: any) => {
      pointInterest.coordinate = e.target._latlng;
    });

    /*marker.on("dragend", (e: any) => {
      pointInterest.coordinate = e.target._latlng;
      this.pointInterest.coordinate = e.target._latlng;

      this.geocodingService
        .inverseGeoconding(
          this.pointInterest.coordinate.lat,
          this.pointInterest.coordinate.lng,
          17
        )
        .subscribe(adress => {
          this.pointInterest.address = adress.display_name;
        });
      this.childModal.show();
    });*/

    marker.bindPopup(popup);
    marker.openPopup();
    let iconUri = ''
    if(pointInterest && pointInterest.typePoi && pointInterest.typePoi.imageUri && pointInterest.typePoi.imageUri.trim() != ''){
       iconUri = pointInterest.typePoi.imageUri;
    }
    else {
      iconUri = imagesPOIDir + pointInterest.imageUri;
    }
    marker.setIcon(
      new Icon({
        iconUrl: iconUri,
        iconAnchor: [-2, 10],
        iconSize: [15, 15],
        popupAnchor: [10, -25]
      })
    );
    this.mapService.addMarkerPoi(marker);
  }

  loadPoiFromRest(){
    this.isDataLoaded = false;
    this.dataManagementService
        .getAllPointInterests()
        .subscribe(pointInterests => {
          this.pointInterestsPoint = [];
          pointInterests.forEach(pointInterest => {
            if (pointInterest.type == "MARKER") {
              this.pointInterestsPoint.push(pointInterest);
            } else if (pointInterest.type == "POLYGON") {
              this.pointInterestsPolygon.push(pointInterest);
            }
          });
          this.dataManagementService.pointInterests = pointInterests;
          this.PageChangePoint({
            page: this.page,
            itemsPerPage: this.itemsPerPage
          });
          this.PageChangePolygon({
            page: this.pagePolgygon,
            itemsPerPage: this.itemsPerPagePolgygon
          });
          this.isDataLoaded = true;
          this.dataManagementService.setPoiInterest(pointInterests);
        });
  }

  chooseIcon(type: any) {
    const exists = this.typePoiSelected.find(t => t === type);
    if (exists) {
      this.typePoiSelected = this.typePoiSelected.filter(t => t !== type);
    } else {
      this.typePoiSelected.push(type);
    }
    this.filterPoiByTypePoi();
  }

}
